// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Columns } from '@locus-taxy/neo-ui';
import { Link } from 'common/components/neo/overrides/Link';
import { useProvider } from 'common/modules/provider';

const Terms = (): React.Node => {
    const { t } = useTranslation('settings');
    const { assets } = useProvider();
    return assets.termsUrl ? (
        <Columns wrap align="right" alignY="bottom" space="xxSmall">
            <Link fontSize={2} target="_blank" href={assets.termsUrl}>
                {t('termsOfUse')}
            </Link>
        </Columns>
    ) : null;
};

export default Terms;
